export const theme = {
  colors: {
    primary: '#D4AF37', // Rich gold
    primaryLight: '#F5EAC4', // Soft gold
    primaryDark: '#A67C00', // Deep gold
    secondary: '#000000', // Black
    secondaryLight: '#333333', // Light black
    background: '#FFFFFF', // White
    backgroundAlt: '#F9F9F9', // Light gray background
    backgroundDark: '#121212', // Dark background
    text: '#000000', // Black text
    textLight: '#666666', // Light text
    lightGray: '#F5F5F5',
    gray: '#CCCCCC',
    darkGray: '#333333',
    error: '#FF0000',
    success: '#28A745',
    info: '#17a2b8',
    warning: '#ffc107',
    overlay: 'rgba(0, 0, 0, 0.7)',
    gradient: {
      gold: 'linear-gradient(135deg, #BF953F 0%, #D4AF37 50%, #AA771C 100%)',
      dark: 'linear-gradient(135deg, #000000 0%, #333333 100%)',
    }
  },
  fonts: {
    main: "'Poppins', sans-serif",
    heading: "'Playfair Display', serif",
    accent: "'Montserrat', sans-serif",
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '992px',
    largeDesktop: '1200px',
  },
  spacing: {
    xxs: '0.125rem', // 2px
    xs: '0.25rem', // 4px
    sm: '0.5rem', // 8px
    md: '1rem', // 16px
    lg: '1.5rem', // 24px
    xl: '2rem', // 32px
    xxl: '3rem', // 48px
    xxxl: '4rem', // 64px
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '16px',
    xl: '24px',
    round: '50%',
    pill: '9999px',
  },
  shadows: {
    small: '0 2px 5px rgba(0, 0, 0, 0.1)',
    medium: '0 5px 15px rgba(0, 0, 0, 0.07)',
    large: '0 10px 25px rgba(0, 0, 0, 0.1)',
    xl: '0 15px 35px rgba(0, 0, 0, 0.1)',
    inner: 'inset 0 2px 5px rgba(0, 0, 0, 0.05)',
    glow: '0 0 20px rgba(191, 149, 63, 0.4)',
    gold: '0 5px 15px rgba(166, 124, 0, 0.3)',
  },
  transitions: {
    short: 'all 0.2s ease-in-out',
    medium: 'all 0.3s ease-in-out',
    long: 'all 0.5s ease-in-out',
    bounce: 'all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
  },
  zIndex: {
    base: 1,
    dropdown: 1000,
    sticky: 1100,
    modal: 1300,
    tooltip: 1400,
  }
};

export type ThemeType = typeof theme; 